export const removeSearchFilter = ({ search, ...filters }) => filters;
